<template>
  <div class="headerWrapper" :style="{'height':height}"><slot></slot></div>
</template>

<script>
    export default {
        name: "index",
        props:{
            height:{
                type:String,
                default:'52px'
            }
        }
    }
</script>

<style scoped lang="scss">
  .headerWrapper{
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    flex-shrink: 0;
  }
</style>



// WEBPACK FOOTER //
// UI/Header/index.vue